export const LcpPaths = {
  FileClaim: "/FileClaim",
  ClaimSubmitted: "/ClaimSubmitted",
  Reapply: (args: { reapplicationKey: string }) =>
    `/Reapply/${args.reapplicationKey}`,

  Landing: "/Landing",
  ApplicationRequiresReview: `/ApplicationRequiresReview`,
  QuoteSaved: (args: { app: { securityKey: string } }) =>
    `/QuoteSaved/${args.app.securityKey}`,
  ApplicationComplete: (args: { app: { securityKey: string } }) =>
    `/ApplicationComplete/${args.app.securityKey}`,
  LossPayeeAdded: `/LossPayeeAdded`,
  LossPayeeAlreadyAdded: `/LossPayeeAlreadyAdded`,
};
